module.exports = __webpack_public_path__ + "static/media/arrow-left.f9f5b67c.svg";